/**
 * Input Schema of Responsavel
 * @author Simpli CLI generator
 */
import {
  Helper,
  Schema,
  FieldSet,
  FieldComponent,
  Component,
} from 'simpli-web-sdk'
import {Responsavel} from '@/model/resource/Responsavel'
import PasswordConfirm from '@/components/PasswordConfirm.vue'

export class InputResponsavelSenhaSchema extends Schema {
  readonly name = 'InputResponsavel'

  isSenhaResponsavelMatch: boolean | null = null
  isSenhaVisualizadorMatch: boolean | null = null
  isSenhaIntegracaoMatch: boolean | null = null

  readonly fieldSet: FieldSet<Responsavel> = {
    senha: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        model: schema.model.senha,
        type: 'password',
        label: this.translateFrom(schema.fieldName),
        validation: 'min:6',
        required: schema.model.idResponsavelPk === 0,
      },
    }),
    repeatSenhaResponsavel: (schema): FieldComponent => ({
      is: PasswordConfirm,
      bind: {
        label: this.translateFrom(schema.fieldName),
        password: schema.model.senha,
        required: Boolean(schema.model.senha),
      },
      on: {
        input: (val: boolean) => (this.isSenhaResponsavelMatch = val),
      },
    }),
    senhaVisualizador: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'password',
        model: schema.model.senhaVisualizador,
        label: this.translateFrom(schema.fieldName),
        validation: 'min:6',
        required: schema.model.idResponsavelPk === 0,
      },
    }),
    repeatSenhaVisualizador: (schema): FieldComponent => ({
      is: PasswordConfirm,
      bind: {
        label: this.translateFrom(schema.fieldName),
        password: schema.model.senhaVisualizador,
        required: Boolean(schema.model.senhaVisualizador),
      },
      on: {
        input: (val: boolean) => (this.isSenhaVisualizadorMatch = val),
      },
    }),
    senhaIntegracao: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'password',
        model: schema.model.senhaIntegracao,
        label: this.translateFrom(schema.fieldName),
        validation: 'min:6',
      },
    }),
    repeatSenhaIntegracao: (schema): FieldComponent => ({
      is: PasswordConfirm,
      bind: {
        label: this.translateFrom(schema.fieldName),
        password: schema.model.senhaIntegracao,
        required: Boolean(schema.model.senhaIntegracao),
      },
      on: {
        input: (val: boolean) => (this.isSenhaIntegracaoMatch = val),
      },
    }),
  }
}
